import { useAtom } from '@xstate/store/react';

import {
	appendTextPreview,
	clearTextPreview,
	closeHer,
	herState,
	openHer,
	setAnimating,
	setExpanded,
	toggleHer,
} from '../state/HerState';

export const useHerStore = (): {
    // State
    isHerActive: boolean; isExpanded: boolean; isAnimating: boolean; contentId: string | null; contentType: string; cloudID: string; textPreview: string;
    // Actions
    toggleHer: (contentId?: string, cloudID?: string, contentType?: string) => void; openHer: (contentId?: string, cloudID?: string, contentType?: string) => void; closeHer: () => void; setExpanded: (expanded: boolean) => void; setAnimating: (animating: boolean) => void; appendTextPreview: (text: string) => void; clearTextPreview: () => void;
} => {
	const state = useAtom(herState);

	return {
		// State
		isHerActive: state.isHerActive,
		isExpanded: state.isExpanded,
		isAnimating: state.isAnimating,
		contentId: state.contentId,
		contentType: state.contentType,
		cloudID: state.cloudID,
		textPreview: state.textPreview,

		// Actions
		toggleHer,
		openHer,
		closeHer,
		setExpanded,
		setAnimating,
		appendTextPreview,
		clearTextPreview,
	};
};
